import { Injectable } from "@angular/core";
import { aspMngr } from "@core_n/asp/AspMngr";
import { SensorsCorePool } from "@core_n/asp/SensorsCorePool";
import { MainStateService } from '@core_n/common/main-state.service';
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { filter } from 'rxjs/operators';
import { PresetWindowState } from "../preset/preset.component";
import { ObjectType } from "./../../asp/AspObject";
import { SensorCoreObject } from "./../../asp/SensorCoreObject";
import { Preset, slotCameraInfo } from "./../preset.model";
import { PresetService } from "./../preset.service";

@Injectable({
  providedIn: "root",
})
export class VideoSplitService {
  public slots = Array.from({ length: 6 }, () => ({
    type: "camera",
    data: null,
  }));
  //public initSensors: SensorCoreObject[] = Array.from({ length: 6 }, () => null);
  public sensors: SensorCoreObject[] = Array.from({ length: 6 }, () => null);
  public connectedDropLists: string[] = [
    "cameraSource",
    ...this.slots.map((_, i) => this.getSlotId(i + 1)),
  ];

  private sensorCorePool = aspMngr.getObjectsPool(
    ObjectType.Sensor
  ) as SensorsCorePool;

  private _changeLayout$: BehaviorSubject<any>;
  get changeLayout$(): Observable<any> {
    return this._changeLayout$.asObservable();
  }

  private _setLayout$ = new Subject<number>();
  get setLayout$(): Observable<number> {
    return this._setLayout$.asObservable();
  }

  get changeFullscreen$(){
    return this.mainStateService.splitScreenToggleClick$.pipe(filter(showSplitScreen => showSplitScreen == false))
  }

  private currentPresetSubject = new BehaviorSubject<Preset | null>(null);
  get currentPreset$(): Observable<Preset | null> {
    return this.currentPresetSubject.asObservable();
  }

  constructor(private presetService: PresetService, private mainStateService: MainStateService,
    ) {
    this._changeLayout$ = new BehaviorSubject<any>({
      id: 1,
      value: "",
      players: 1,
      key: "1",
    });
  }

  public notifyChangeLayout(layout: any): void {
    if (this._changeLayout$.value.id != layout.id) {
      this._changeLayout$.next(layout);
    }
  }

  public changeLayout(layoutId: number): void {
    this._setLayout$.next(layoutId);
  }

  public initSplitScreen(){
    this.sensors = Array.from({ length: 6 }, () => null);
    this.currentPresetSubject.next(null)
    return this.sensors;
  }

  showAddPreset() {
    const presetCameras: slotCameraInfo[] = this.sensors
    .map((s, index) => {
      if (s == null) return null;
      return {
        cameraId: s?.sensorID.toString(),
        activeStreamName:'',
        cameraStreamName: s.streamName,
        cameraName: s.name,
        slot: index
      };
    }).filter((s) => s);
    const preset: Preset = {
      name: "",
      cameras: presetCameras,
      layoutId: this._changeLayout$.value.id,
    };
    var state: PresetWindowState = "addPreset";
    
    const currentPreset = this.currentPresetSubject.value;
    if (currentPreset){
      preset.id = currentPreset.id;
      preset.name = currentPreset.name;
      state = "updatePreset";
    }
    this.presetService.showPreset(preset, state);
  }

  loadPreset(preset: Preset) {
    this.changeLayout(preset.layoutId);
    this.sensors = this.sensors.map((sensor, index) => {
      const camera = preset.cameras.find((c) => c.slot === index);
      return camera ? this.fetchCamera(camera.cameraStreamName) : null;
    });
    this.currentPresetSubject.next(preset);
  }

  fetchCamera(str: string) {
    str = str.toLowerCase();
    if (!this.sensorCorePool.name2Obj.has(str)) {
      return null;
    }

    return this.sensorCorePool.name2Obj.get(str);
  }

  getSlotId(index: number) {
    return `player${index}`;
  }
}
